var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('nav', {
    attrs: {
      "div": "navbar",
      "height": 140
    }
  }, [_c('div', {
    staticClass: "top"
  }, [_c('div', {
    staticClass: "logo"
  }, [_c('a', {
    attrs: {
      "href": _vm.generateURL('/')
    }
  }, [_vm.$root.theme === 'day' ? _c('img', {
    staticStyle: {
      "height": "50px"
    },
    attrs: {
      "src": require("@/assets/explorer_logo_dark.svg")
    }
  }) : _c('img', {
    staticStyle: {
      "height": "50px"
    },
    attrs: {
      "src": require("@/assets/explorer_logo.svg")
    }
  }), _vm._m(0)])]), _c('div', {
    staticClass: "links"
  }, [_c('div', {
    staticClass: "routes"
  }, [_c('a', {
    attrs: {
      "href": _vm.explorerURL
    }
  }, [_vm._v("Explorer")]), _c('a', {
    attrs: {
      "target": "_blank",
      "href": _vm.walletURL
    }
  }, [_vm._v("Wallet")]), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://dcomm.network"
    }
  }, [_vm._v("Community")]), _c('DayNightToggle')], 1)])]), _c('div', {
    staticClass: "bottom mb-30"
  }, [_c('div', {
    staticClass: "left routes"
  }, [_c('a', {
    staticClass: "tab_routes",
    attrs: {
      "aria-selected": _vm.isRelatedRoute(0),
      "href": _vm.generateURL('/')
    }
  }, [_vm._v("Home")]), _c('a', {
    staticClass: "tab_routes",
    attrs: {
      "aria-selected": _vm.isRelatedRoute(1),
      "href": _vm.generateURL('/action')
    }
  }, [_vm._v(" Action ")]), _c('a', {
    staticClass: "tab_routes",
    attrs: {
      "aria-selected": _vm.isRelatedRoute(2),
      "href": _vm.generateURL(_vm.astChainURL)
    }
  }, [_vm._v(" Asset ")]), _c('a', {
    staticClass: "tab_routes",
    attrs: {
      "aria-selected": _vm.isRelatedRoute(3),
      "href": _vm.generateURL(_vm.athChainURL)
    }
  }, [_vm._v("Authority")]), _c('a', {
    staticClass: "tab_routes",
    attrs: {
      "aria-selected": _vm.isRelatedRoute(4),
      "href": _vm.generateURL('/blockchain')
    }
  }, [_vm._v("Blockchains")])]), _c('div', {
    staticClass: "right"
  }, [_c('SearchBar', {
    attrs: {
      "placeholder": "Search for blocks, accounts, transactions..."
    },
    on: {
      "search": _vm.onsearch
    }
  }), _c('NetworkMenu')], 1)])]);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('h1', [_c('span', {
    staticClass: "hide"
  }, [_vm._v("DComm Explorer")])]);
}]

export { render, staticRenderFns }